/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WidgetTypeFromJSON, WidgetTypeToJSON } from './';
export function WidgetFromJSON(json) {
    return WidgetFromJSONTyped(json, false);
}
export function WidgetFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        title: json['title'],
        type: WidgetTypeFromJSON(json['type']),
        config: json['config'],
        GridId: json['GridId'],
    };
}
export function WidgetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        title: value.title,
        type: WidgetTypeToJSON(value.type),
        config: value.config,
        GridId: value.GridId,
    };
}
